/**
 * Notice
 * ヘッダーのお問い合わせ通知（吹き出し）の閉じる制御。複数インスタンス対応。
 * 閉じてもその場限り（永続化しない）＝リロードすると毎回再表示する。
 *
 * @usage
 * HTML:
 * <div class="js-notice">
 *   ...<button class="js-notice-close" aria-label="閉じる"></button>
 * </div>
 * JS: new Notice();
 */
export default class Notice {
  constructor(options = {}) {
    this.options = {
      selector: '.js-notice',
      closeSelector: '.js-notice-close',
      hiddenClass: 'is-hidden',
      ...options
    };

    this.notices = Array.from(document.querySelectorAll(this.options.selector));

    if (this.notices.length > 0) {
      this.init();
    }
  }

  init() {
    this.notices.forEach((notice) => {
      const closeBtn = notice.querySelector(this.options.closeSelector);
      if (closeBtn) {
        closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.close(notice);
        });
      }
    });
  }

  close(notice) {
    notice.classList.add(this.options.hiddenClass);
    notice.dispatchEvent(new CustomEvent('notice:closed'));
  }
}
